import React from 'react'
import MyTable from '../../../../UI/table/MyTable'
import { TableCell } from '@mui/material'
import MyTableNotFound from '../../../../UI/table/MyTableNotFound'
import SupplyOrderItem from './SupplyOrderItem'
import { useSelector } from 'react-redux'
import MyTableCheckBoxAll from '../../../../UI/table/MyTableCheckBoxAll'

const SupplyOrderItemsTable = ({ checked, setChecked }) => {

    const supplyOrder = useSelector(state => state.supplyOrder.supplyOrder)

  return (
    <MyTable
        head={
            <>
                <MyTableCheckBoxAll
                    items={supplyOrder.items}
                    checked={checked}
                    setChecked={setChecked}
                />
                <TableCell align="center">№</TableCell>
                <TableCell align="center">Назва</TableCell>
                <TableCell align="center">Кількість</TableCell>
                <TableCell align="center">Посилання</TableCell>
                <TableCell align="center">Погодження</TableCell>
                <TableCell align="center">Отримано?</TableCell>
                <TableCell align="center">Дії</TableCell>
            </>
        }
        body={
            // supplyOrderItems && supplyOrderItems.length > 0 ?
            //     supplyOrderItems.map((supplyOrderItem, index) => 
            supplyOrder.items && supplyOrder.items.length > 0 ?
                supplyOrder.items.map((supplyOrderItem, index) => 
                    <SupplyOrderItem
                        key={supplyOrderItem.id}
                        index={index}
                        supplyOrderItem={supplyOrderItem} 
                        checked={checked}
                        setChecked={setChecked}
                    />
                )
            : 
                <MyTableNotFound
                    text='Позицій не знайдено' 
                    // columns={6}
                />
        }
        name='позицій'
        hidePagination={true}
    />
  )
}

export default SupplyOrderItemsTable